/* unplugin-vue-components disabled */import script from "./ComplaintScamComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintScamComponents.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintScamComponents.vue?vue&type=style&index=0&id=75f643be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f643be"]])

export default __exports__